import Vue from 'vue'
import Vuex from 'vuex'
import snowflake from './modules/snowflake'
import queryRepo from './modules/query-repo'
import queryPad from './modules/query-pad'
import forum from './modules/forum'
import user from './modules/user'
import queryWorkspace from './modules/query-workspace'
import adminConsole from './modules/admin-console'
import scheduledQuery from './modules/scheduled-query'
import customDashboard from './modules/custom-dashboard'

Vue.use(Vuex)

// Vuex Store Initialization
export default new Vuex.Store({
  modules: {
    snowflake,
    queryRepo,
    queryPad,
    forum,
    user,
    queryWorkspace,
    adminConsole,
    scheduledQuery,
    customDashboard
  }
})
